<swal #warnAlert
  title="Warning" i18n-title
  text="Are you sure you want to delete this Fixed Fee?" i18n-text
  icon="warning"
  [swalOptions]="swalOptions">
</swal>
<form [formGroup]="nonStandardFeeForm" fxLayoutWrap novalidate>
  <div class="fee-amount">
    <div class="fee-amount__header" fxLayout="row wrap" fxLayoutAlign="space-between center">
      <ng-container *ngIf="transaction.transaction_type !== 'sale'">
        <div class="formfields__container" fxFlex="33">
          <iv-currency-field
            label="CBRE Fee Amount" i18n-label
            controlName="amount"
            prefixed="true"
            [formControl]="nonStandardFeeForm.get('amount')"
            [currency]="currencySymbol"
            [required]="true">
          </iv-currency-field>
        </div>
      </ng-container>

      <div class="formfields__container" fxFlex="33">
        <iv-currency-field
          *ngIf="transaction.rep_role === 'tenant' || transaction.rep_role === 'landlord'"
          label="Additional Transaction Amount" i18n-label
          controlName="additional_fee"
          prefixed="true"
          [formControl]="nonStandardFeeForm.get('additional_fee')"
          [currency]="currencySymbol">
        </iv-currency-field>
      </div>

      <div *ngIf="transaction.transaction_type !== 'sale'" class="delete-action" fxFlex="33" fxLayoutAlign="end">
        <button type="button" mat-icon-button (click)="showDeleteAlert()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>

    <div class="fee-amount__content">
      <div class="notes">
        <div class="notes__header">
          <span>{{ this.header }}<span>{{ this.subheader }}</span></span>
        </div>
        <div class="notes__text">
          <mat-form-field floatLabel="never">
            <textarea
              matInput
              maxlength="254"
              placeholder="Add Note Here" i18n-placeholder
              matTextareaAutosize
              formControlName="notes">
            </textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</form>
